import type { GeneratedDocument } from '../../types/agreementDocuments.types';

interface Props {
    template: NonNullable<GeneratedDocument['template']>;
}

export function TemplateCell({ template }: Props) {
    return (
        <div>
            {template.name}
            <span className="block text-xs text-mp-muted">Version {template.versionNumber}</span>
        </div>
    );
}
